import { jsx as _jsx } from "react/jsx-runtime";
import { FieldValue } from "../../molecules/subcomponents";
import { RowInput } from "../../subcomponents";
var CustomerName = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    var fullName = [firstName, lastName].join(" ");
    return (_jsx(RowInput, { children: _jsx(FieldValue, { children: fullName }) }));
};
export default CustomerName;
